module.exports = __webpack_public_path__ + "img/guaranteed-review.b0e15fe9.png";